
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import 'quill/dist/quill.snow.css';
import { AuthProvider } from "./contexts/AuthContext.tsx";
import { AdminProvider } from "./contexts/AdminContext.tsx";

createRoot(document.getElementById("root")!).render(
  <AuthProvider>
    <AdminProvider>
    <App />
    </AdminProvider>
  </AuthProvider>
);
